import {put, select, takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {addCoins, addLives, buyLives} from "../actions";
import {IApplicationState} from "../../index";

export default function* watchBuyLives() {
    yield takeEvery(getType(buyLives), function* ({ payload }: ActionType<typeof buyLives>) {
        if (payload > 0) {
            const { liveCost, coins } = yield select(({ settings, player }: IApplicationState) => ({
                coins: player.coins,
                liveCost: settings.gameBalance.liveCost,
            }));

            const totalCost = liveCost * payload;
            if (totalCost > coins)
                return;

            yield put(addCoins(-totalCost, "purchased_lives"));
            yield put(addLives(payload, "purchased_item_for_coins"));
        }
    });
}